import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CircularProgress, FormHelperText, InputLabel } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { s3baseUrl } from "src/config/config";
import { EditWorkoutApi } from "src/DAL/workout/workout";
import {
  generateExerciseArray,
  mapExercise,
  show_proper_words,
} from "src/utils/constant";

let workbook_type = [
  { _id: "workout-type", title: "Workout" },
  { _id: "meal-type", title: "Nutrition" },
  { _id: "mindset-type", title: "Mindset" },
];

function AddOrUpdateModelLibrary({
  open,
  setOpen,
  workoutTypes,
  openFor,
  setOpenFor,
  data,
  searchFunction,
  type,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [addArray, setaddArray] = useState([]);
  const [file, setProfileImage] = useState();
  const [oldImage, setOldImage] = useState();

  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    title: "",
    status: true,
    image: {},
    type: "",
    short_description: "",
    difficulty_levels: [],
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const fileChangedHandler = (e) => {
    setProfileImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };

  const handleClose = () => {
    setOpenFor("Add");
    setOldImage("");
    setIsLoading(false);
    setOpen(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (openFor == "Edit") {
      setIsLoading(true);

      const { exerciesArray, isError } = generateExerciseArray(
        addArray,
        enqueueSnackbar,
      );

      if (isError) {
        return;
      }
      const formData = new FormData();
      formData.append("title", inputs?.title);
      if (file) {
        formData.append("image", inputs?.image);
      }
      if (type === "workbook") {
        formData.append("library_type", inputs?.type);
      } else {
        formData.append("type", inputs?.type);
      }
      formData.append("description", inputs?.short_description);
      formData.append("status", inputs.status);
      formData.append("exercises", JSON.stringify(exerciesArray));
      formData.append(
        "difficulty_levels",
        JSON.stringify(inputs?.difficulty_levels),
      );
      const result = await EditWorkoutApi(formData, data.workout_slug);
      if (result.code == 200) {
        enqueueSnackbar(result.message, { variant: "success" });
        searchFunction();
        handleClose();
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    } else {
      if (!file) {
        enqueueSnackbar("Please Upload Image", { variant: "error" });
        return;
      }
      if (type === "video") {
        navigate(`/videoset-add`, {
          state: inputs,
        });
      } else if (type === "comment") {
        navigate(`/commentset-add`, {
          state: inputs,
        });
      } else if (type === "workbook") {
        navigate(`/workbook-add`, {
          state: inputs,
        });
      } else if (type === "mindset") {
        navigate(`/mindset-add`, {
          state: inputs,
        });
      } else if (type === "food") {
        navigate(`/food_matters-add`, {
          state: inputs,
        });
      } else {
        navigate(`/workout-add`, {
          state: inputs,
        });
      }
      setOpen(false);
    }
  };

  const populateInputs = (values = {}) => {
    setInputs((prev) => ({
      ...prev,
      title: values.title || "",
      status: values.status ?? true,
      type: values.type || "",
      short_description: values.short_description || "",
      image: "",
      difficulty_levels: values.difficulty_levels || [],
    }));
  };

  useEffect(() => {
    setIsLoading(false);

    if (openFor === "Edit") {
      const mappedExercises = data?.exercises?.map(mapExercise) || [];
      setaddArray(mappedExercises);
      setOldImage(data?.image?.thumbnail_1);
      populateInputs({
        title: data?.title,
        status: data?.status,
        type: type === "workbook" ? data?.library_type : data?.type,
        short_description: data?.description,
        difficulty_levels: data?.difficulty_levels,
      });
    } else {
      setProfileImage("");
      populateInputs();
    }
  }, [open]);

  let type_name = type === "food" ? "Daily Meal Plan" : show_proper_words(type);

  return (
    <>
      <button className="small-contained-button" onClick={handleOpen}>
        Add {type_name}
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "65%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            border: "none",
            overflow: "auto",
            maxHeight: "90vh",
          }}
        >
          <CloseIcon
            onClick={handleClose}
            style={{
              fill: "var(--portal-theme-primary)",
              backgroundColor: "var(--portal-theme-secondary)",
              borderRadius: "50px",
              padding: "4px",
              cursor: "pointer",
            }}
            sx={{ position: "absolute", top: 5, right: 5 }}
          />
          <h2 id="simple-modal-title">
            {`${openFor === "Edit" ? "Edit" : "Build"} ${type_name}`}
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row mt-3">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <div className="row">
                  <div className="col-12">
                    <FormControl fullWidth>
                      <TextField
                        id="outlined-basic"
                        label={`${type_name} Name`}
                        variant="outlined"
                        fullWidth
                        name="title"
                        required
                        value={inputs.title}
                        onChange={handleChange}
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mt: 2 }} required>
                      <InputLabel id="demo-simple-select-label">
                        {type_name} Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="type"
                        value={inputs.type}
                        label={`${type_name} Type`}
                        onChange={handleChange}
                        MenuProps={{
                          PaperProps: { style: { maxHeight: 260 } },
                        }}
                      >
                        {type === "workbook"
                          ? workbook_type.map((item) => (
                              <MenuItem value={item._id} key={item._id}>
                                {item.title}
                              </MenuItem>
                            ))
                          : workoutTypes.map((item) => (
                              <MenuItem value={item._id} key={item._id}>
                                {item.title}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-12 col-md-6">
                    <FormControl fullWidth sx={{ mt: 2 }}>
                      <InputLabel id="demo-simple-select-label">
                        {type_name} Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="status"
                        value={inputs.status}
                        label={`${type_name} Status`}
                        onChange={handleChange}
                      >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-12 col-md-6">
                    <FormControl fullWidth sx={{ mt: 2 }} required>
                      <InputLabel id="demo-simple-select-label">
                        Difficulty Levels
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        multiple
                        name="difficulty_levels"
                        value={inputs.difficulty_levels}
                        label="Difficulty Levels"
                        onChange={handleChange}
                      >
                        <MenuItem value="novice">Novice</MenuItem>
                        <MenuItem value="intermediate">Intermediate</MenuItem>
                        <MenuItem value="advanced">Advanced</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 ">
                <FormControl
                  fullWidth
                  sx={{
                    mt: { xs: 2, sm: 2, md: 0, lg: 0 },
                  }}
                >
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Short Description"
                    multiline
                    rows={7}
                    required
                    name="short_description"
                    value={inputs.short_description}
                    onChange={handleChange}
                  />
                  <FormHelperText sx={{ fontSize: 10 }}>
                    (Maximum limit 250 characters)
                  </FormHelperText>
                </FormControl>
              </div>
            </div>
            <div className="my-3">
              <div className="row w-100 div-style ms-0 pt-0">
                <div className="col-lg-5 col-md-5 col-sm-12">
                  <p className="">Upload Image *</p>
                  <FormHelperText className="pt-0" sx={{ fontSize: 10 }}>
                    Image Size(1000 X 670) ("JPG", "JPEG", "PNG","WEBP")
                  </FormHelperText>
                </div>
                <div className=" col-lg-2 col-md-2 col-sm-12">
                  {file ? (
                    <img className="image-border" src={file} height="50" />
                  ) : oldImage ? (
                    <img
                      className="image-border"
                      src={s3baseUrl + oldImage}
                      height="50"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12  text-lg-end text-md-end text-sm-start pt-2">
                  <label htmlFor="contained-button-file">
                    <input
                      accept=".jpg, .jpeg, .png, .webp"
                      id="contained-button-file"
                      multiple
                      type="file"
                      name="image"
                      onChange={fileChangedHandler}
                      style={{ display: "none" }}
                    />
                    <Button
                      className="small-contained-button"
                      startIcon={<FileUploadIcon />}
                      component="span"
                      variant="contained"
                      size="small"
                    >
                      Upload
                    </Button>
                  </label>
                </div>
              </div>
              {inputs.image.name == "" ? (
                ""
              ) : (
                <p className="text-secondary">{inputs.image.name}</p>
              )}
            </div>
            <Button
              className="mt-3"
              variant="contained"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : openFor === "Edit" ? (
                "Save"
              ) : (
                "START BUILDING"
              )}
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
}

export default AddOrUpdateModelLibrary;
